const paths = {
  login: "/login",
  logout: "/logout",
  notfound: "/not-found",
  inicio: "/inicio",
  root: "/",

  admin: (company_slug: string) => ({
    pacientes: {
      root: `/${company_slug}/admin/pacientes`,
      nuevo: `/${company_slug}/admin/pacientes/nuevo`,
      editar: (paciente_id: string) => `/${company_slug}/admin/pacientes/${paciente_id}/editar`,
      ver: (paciente_id: string) => `/${company_slug}/admin/pacientes/${paciente_id}`,
      consultas: {
        root: (paciente_id: string) => `/${company_slug}/admin/pacientes/${paciente_id}/consultas`,
        nuevo: (paciente_id: string) => `/${company_slug}/admin/pacientes/${paciente_id}/consultas/nuevo`,
        editar: (paciente_id: string, consulta_id: string) =>
          `/${company_slug}/admin/pacientes/${paciente_id}/consultas/${consulta_id}/editar`,
        ver: (paciente_id: string, consulta_id: string) =>
          `/${company_slug}/admin/pacientes/${paciente_id}/consultas/${consulta_id}`
      }
    },
    usuarios: {
      root: `/${company_slug}/admin/usuarios`,
      nuevo: `/${company_slug}/admin/usuarios/nuevo`,
      ver: (user_id: string) => `/${company_slug}/admin/usuarios/${user_id}`
    },
    planAlimentacion: {
      root: `/${company_slug}/admin/plan-alimentacion`,
      nuevo: `/${company_slug}/admin/plan-alimentacion/nuevo`,
      ver: (plan_id: string) => `/${company_slug}/admin/plan-alimentacion/${plan_id}`,
      editar: (plan_id: string) => `/${company_slug}/admin/plan-alimentacion/${plan_id}/editar`
    },
    subscripcion: `/${company_slug}/admin/subscripcion`,
    asistenteAi: `/${company_slug}/admin/asistente-ai`,
    login: `/${company_slug}/admin`,
    logout: `/${company_slug}/logout`
  }),

  pacientes: {
    root: (company_slug: string) => `/${company_slug}/pacientes`
  },
  api: {
    login: "/api/login"
  }
}

export default paths
